<!-- MINIMAP CONTAINER -->
<div 
    #minimapContainer 
    (click)="onMinimapClick()"
    (keypress.enter)="onMinimapClick()"
    [class]="{'hidden': isMinimapHidden}"
    class="w-[110px] h-[100px] md:w-[150px] md:h-[105px] bg-black/80 rounded-md pointer-events-auto backdrop-blur-md overflow-hidden opacity-10 hover:opacity-100 cursor-pointer"
    tabindex="0"
>
 
    <!-- WRAPPER -->
    <div class="h-full w-full pointer-events-none ">

        <!-- TEMP COMMENT UNTIL ISSUE IS FIXED IN DVM -->
        <!-- @if(useNavigable){
            <dvm-navigable-minimap [linkedMapViewer]="dvmService.viewer"/> 
        }
        @else { 
            <dvm-map-viewer  class="h-full" [service]="minimap"/> 
        } -->
        
        <!-- TEMP SOLUTION -->
        <!-- NAVIGABLE MINIMAP -->
        <dvm-navigable-minimap #navigableMinimap [class]="{'hidden': !useNavigable || !isLoaded}" [linkedMapViewer]="dvmService.viewer"/>
        <!-- MINIMAP CUSTOM (VIEWER SERVICE) -->
        @if(view()){
            <dvm-map-viewer [class]="{'hidden': useNavigable}" class="h-full" [service]="minimap"/>
        }

    </div>  

</div>
